import { toast } from "react-toastify";

const initState = {
  adcardloading: false,
  controllerloading: false,
  controller: null,
  adcards: [],
  adcard: new Map(),
};

const adcardReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ADHISTORY":
      return {
        ...state,
        adcardloading: false,
        adcards: action.payload,
      };

    case "GET_ADHISTORY_ERROR":
      toast.error("Couldn't Retreive Your Advertisements");
      console.log(action.payload.toString());
      return {
        ...state,
        adcardloading: false,
      };
    case "GET_ADCARD":
      const tempcard = state.adcard;
      tempcard.set(action.payload.id, action.payload);
      return {
        ...state,
        adcardloading: false,
        adcard: tempcard,
      };

    case "GET_ADCARD_ERROR":
      toast.error("Couldn't Retreive Your Advertisement");
      console.log(action.payload.toString());
      return {
        ...state,
        adcardloading: false,
      };

    case "LOAD_ADHISTORY":
      return {
        ...state,
        adcardloading: true,
      };
    case "GET_CONTROLLER":
      return {
        ...state,
        controllerloading: false,
        controller: action.payload,
      };

    case "GET_CONTROLLER_ERROR":
      toast.error("Remaining Days Might be Incorrect");
      console.log(action.payload.toString());
      return {
        ...state,
        controllerloading: false,
      };
    case "LOAD_CONTROLLER":
      return {
        ...state,
        controllerloading: true,
      };
    default:
      return state;
  }
};

export default adcardReducer;
